const states = {
  soldoutWaitlistEnabled: 'soldoutWaitlistEnabled',
  soldoutWaitlistNotEnabled: 'soldoutWaitlistNotEnabled',
  salesEnded: 'salesEnded',
  unavailableAllHidden: 'unavailableAllHidden',
  unavailableOnlyAtDoor: 'unavailableOnlyAtDoor',
  unavailableGeofenced: 'unavailableGeofenced',
  semiAvailableAllLocked: 'semiAvailableAllLocked',
  semiAvailableNotStarted: 'semiAvailableNotStarted',
  salesEndedEventOver: 'salesEndedEventOver',
  availableStandard: 'availableStandard',
  noData: 'noData',
  noIdea: 'noIdea',
}

function ratesCurrentlyAvailable(rates) {
  const currentTime = new Date().getTime() / 1000
  return rates?.nodes.some((rate) => {
    const rateAwaitingPreemtiveRateSoldOut = rates?.nodes.some(node => (
      node.id === rate.preemptiveRateId) && (node.capacity > 0
    ))
    // rate is available if not having future start stamp, and not awaiting preemptive rate sold out
    return (!rate.startStamp || rate.startStamp <= currentTime) && !rateAwaitingPreemtiveRateSoldOut
  })
}

const eventStateModel = (eventData) => {
  if (!eventData) return states.noData

  // "regular" here means not locked, not soldAtDoor, not hidden etc.
  const ticketsSoldOut = eventData.soldOut
  const hasRegularRatesAvailable = eventData.rates?.nodes.length !== 0
  const hasOngoingOrFutureTimeSlots = eventData.totalAvailableTimeSlotCount !== 0
  const allTicketsLocked = !hasRegularRatesAvailable && eventData.rateStateExists?.locked
  const allTicketsAtDoor = !hasRegularRatesAvailable && eventData.rateStateExists?.soldAtDoor
  const allTicketsHidden = !hasRegularRatesAvailable && eventData.rateStateExists?.inactive
  const eventGeofenced = SSR_DATA.countryCode && eventData.availableCountries?.length &&
    !eventData.availableCountries?.includes(SSR_DATA.countryCode.toUpperCase())
  const { allowWaitlist, salesEnded } = eventData

  const anyRatesCurrentlyAvailable = ratesCurrentlyAvailable(eventData.rates)
  const ticketSalesStarted = (hasOngoingOrFutureTimeSlots && anyRatesCurrentlyAvailable)

  // note - there will soon be a "draft" type state where we will say smth like "ticket coming soon"
  if (eventGeofenced) return states.unavailableGeofenced
  if (eventData.state === 'EXPIRED' || !hasOngoingOrFutureTimeSlots) return states.salesEndedEventOver
  if (salesEnded && eventData.rateStateExists?.locked) return states.semiAvailableAllLocked
  if (salesEnded) return states.salesEnded
  if (ticketsSoldOut && allowWaitlist) return states.soldoutWaitlistEnabled
  if (ticketsSoldOut && !allowWaitlist) return states.soldoutWaitlistNotEnabled
  if (allTicketsLocked) return states.semiAvailableAllLocked
  if (allTicketsHidden) return states.unavailableAllHidden
  if (allTicketsAtDoor) return states.unavailableOnlyAtDoor
  if (!ticketSalesStarted) return states.semiAvailableNotStarted

  return states.availableStandard
}

export default eventStateModel
